import { createStore } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { deleteAuthHeader, setAuthHeader } from '~/api/clients';
import { normalizeTokenType } from '~/api/utils';

import type { ADCJWTPayload } from './types';

type AuthState = {
  accessToken: string | null;
  tokenType: string | null;
  userInfo?: ADCJWTPayload | null;
};

const authAtom = atomWithStorage<AuthState>(
  'auth',
  {
    accessToken: null,
    tokenType: null,
    userInfo: null,
  },
  undefined,
  { getOnInit: true },
);

export const authStore = createStore();

export const authState = {
  get: () => authStore.get(authAtom),
  set: (auth: AuthState) => {
    authStore.set(authAtom, auth);
    // Set the authorization header for all API clients
    setAuthHeader(
      'Authorization',
      `${normalizeTokenType(auth.tokenType)} ${auth.accessToken ?? ''}`,
    );
  },
  reset: () => {
    authStore.set(authAtom, {
      accessToken: null,
      tokenType: null,
    });
    // Clear the authorization header for all API clients
    deleteAuthHeader('Authorization');
  },
  sub: (callback: (auth: AuthState) => void) => {
    const unsub = authStore.sub(authAtom, () => {
      callback(authStore.get(authAtom));
    });

    return () => {
      unsub();
    };
  },
  /**
   * Returns the idnID from the current userInfo, or null if not present.
   */
  getIDNId: () => {
    const userInfo = authStore.get(authAtom).userInfo;

    return userInfo ? (userInfo.idnID ?? null) : null;
  },
} as const;
